
































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import Modal from '@components/Modal'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'
import AudienceAvailabilityList from '@ui/AudienceSetWizard/components/AudienceAvailabilityList'

settings =
  name: 'PartnershipSpecialTermsStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      Modal,
      StepContainer,
      PartnershipSteps,
      AudienceAvailabilityList,
    }

    data: ->
      allSelected: false
      selectedAudienceAvailabilityKeys: []
      termsModal:
        show: false
        description: ''
        audienceAvailabilityKeys: []

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities
      hasAudienceAvailabilitiesSelected: -> @selectedAudienceAvailabilityKeys.length > 0

    methods:
      hiToggleAllSelected: (checked) ->
        if checked
          @selectedAudienceAvailabilityKeys = @audienceAvailabilities.map((item) -> item.key)
        else
          @selectedAudienceAvailabilityKeys = []

      hiBulkSetSpecialTerms: ->
        @termsModal =
          show: true
          description: ''
          audienceAvailabilityKeys: @selectedAudienceAvailabilityKeys

      hiEditSpecialTerm: (audienceAvailability) ->
        @termsModal =
          show: true
          description: audienceAvailability.special_terms.description
          audienceAvailabilityKeys: [audienceAvailability.key]

      hiCloseTermsModal: ->
        @closeTermsModal()

      hiSaveTermsModal: ->
        for key in @termsModal.audienceAvailabilityKeys
          audienceAvailability = @audienceAvailabilities.find((item) => item.key is key)
          audienceAvailability.special_terms.description = @termsModal.description.trim()
        @wizard.syncAndSave()
        @closeTermsModal()

      closeTermsModal: ->
        @termsModal.show = false
        @clearSelectedAudienceAvailabilities()

      clearSelectedAudienceAvailabilities: ->
        @selectedAudienceAvailabilityKeys = []

      getSelectedAudienceAvailabilities: ->
        @audienceAvailabilities.filter((item) => item.key in @selectedAudienceAvailabilityKeys)

    watch:
      selectedAudienceAvailabilityKeys: ->
        @allSelected = @selectedAudienceAvailabilityKeys.length is @audienceAvailabilities.length

export default VueOptions.vue settings
